import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const DateRangePicker = ({ label, value, onChange, className = "" }) => {
  const presets = [
    { label: 'Today', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
    { label: 'Yesterday', value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')] },
    { label: 'This Week', value: [dayjs().startOf('week'), dayjs().endOf('day')] },
    { label: 'This Month', value: [dayjs().startOf('month'), dayjs().endOf('day')] },
    { label: 'Last 7 Days', value: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')] },
    { label: 'Last 30 Days', value: [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')] },
  ];

  return (
    <div className={`product-setup-filter-item ${className}`}>
      {label && <div className="pcu-font-11 pcu-font-700 pcu-margin-bottom-6 pcu-color-title pcu-opacity-50 pcu-letter-spacing-1 pcu-uppercase" style={{ fontFamily: 'var(--font-family-primary)' }}>{label}</div>}
      <RangePicker
        className="pcu-w-100 pcu-radius-8"
        style={{ height: '34px' }}
        size="middle"
        onChange={onChange}
        value={value}
        presets={presets}
      />
    </div>
  );
};

export default DateRangePicker;
